<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
export default {
  name: "App"
};
</script>

<style lang="scss">
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  width: 100%;
  height: 100%;
  overflow: hidden;
  /* margin-top: 60px; */
}
.date-select {
  position: fixed !important;
  top: 1rem !important;
  right: 1rem !important;
  font-size: 2rem !important;
  color: #fff !important;
}
.btn-save {
  position: fixed !important;
  top: 1.2rem !important;
  right: 1rem !important;
  font-size: 1.125rem !important;
  z-index: 1;
  font-family: PingFangSC-Medium;
  font-size: 0.875rem !important;
  color: #8f9bb3 !important;
}
.add-box {
  height: 5.125rem;

  background: #ffffff;
  box-shadow: 0 0 1px 0 rgba(10, 22, 70, 0.06),
    20px 0 46px -10px rgba(10, 22, 70, 0.1);
  position: fixed;
  bottom: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100%;
  .btn {
    border-radius: 1.375rem;
    background-image: linear-gradient(90deg, #ff7901 3%, #fe5845 100%);
    color: #fff;
    font-size: 1.2rem;
    padding: 0 1rem;
    width: 92%;
  }
}
.base {
  /* height: 77vh; */
  overflow-y: auto !important;
  height: 100% !important;
  padding-bottom: 1rem !important;
  box-sizing: border-box !important;
}
.other-box {
  height: 100%;
}
.divider {
  color: #999;
  border-color: #999;
  width: 68%;
  margin: 1rem auto;
}
</style>



// WEBPACK FOOTER //
// src/App.vue